import { useT } from "@transifex/react";
import type { ReactNode } from "react";
import type { LoginErrorVariants } from "../../context/classMemberLoginErrors";
import ClassLoginForm from "./ClassLoginForm";
import { LOGIN_COLUMN_CLASS, SECONDARY_PILL_BUTTON_CLASS } from "./classMemberFormStyles";

interface ClassMemberEntryProps {
    header: ReactNode;
    notice?: string;
    classCode: string;
    initialPersonalCode?: string;
    loginError: LoginErrorVariants;
    isLoggingIn: boolean;
    onLogin: (classCode: string, personalCode: string) => void;
    onJoin: () => void;
}

const ClassMemberEntry = (props: ClassMemberEntryProps) => {
    const t = useT();

    const t_or = t("OR", { _tags: "ClassMemberLogin, ClassMemberEntry" });
    const t_noCodeYet = t("Don't have a code for this classroom yet?", { _tags: "ClassMemberLogin, ClassMemberEntry" });
    const t_joinClass = t("Join the class", { _tags: "ClassMemberLogin, ClassMemberEntry" });

    return (
        <div
            className={`${LOGIN_COLUMN_CLASS} gap-xxl`}
            data-testid="class-member-entry"
        >
            {props.header}
            <div className="flex w-full flex-col items-center gap-s">
                {props.notice && <p className="self-start text-m text-p6-grey-dark">{props.notice}</p>}
                <ClassLoginForm
                    showClassCode={false}
                    showPersonalCodeLabel
                    initialClassCode={props.classCode}
                    initialPersonalCode={props.initialPersonalCode}
                    error={props.loginError}
                    isSubmitting={props.isLoggingIn}
                    onSubmit={props.onLogin}
                />
                <div
                    className="flex w-full items-center gap-s py-xs"
                    aria-hidden
                >
                    <span className="h-px flex-1 bg-p6-grey-light" />
                    <span className="text-m text-p6-grey-dark">{t_or}</span>
                    <span className="h-px flex-1 bg-p6-grey-light" />
                </div>
                <p className="self-start text-m text-p6-grey-dark">{t_noCodeYet}</p>
                <button
                    type="button"
                    data-testid="button-join-class"
                    onClick={props.onJoin}
                    className={SECONDARY_PILL_BUTTON_CLASS}
                >
                    {t_joinClass}
                </button>
            </div>
        </div>
    );
};

export default ClassMemberEntry;
